/* PikeFit: unified AJAX add-to-cart for the store's custom add forms.
   Covers .pfbs__form (best-sellers), .pfo__form (offer selector),
   .lp__offer-form / .lp__atc-form (landing pages). Adds via /cart/add.js
   requesting the cart-drawer section so it morphs instantly, dispatches
   Horizon's native 'cart:update' event (refreshes drawer items, cart-count
   bubble and free-shipping bar), then slides the drawer open. Falls back to
   the form's native /cart submit on any error or when no drawer is present.
   Horizon's native product form (PDP) is intentionally NOT intercepted. */
(function () {
  var SELECTOR = '.pfbs__form, .pfo__form, .lp__offer-form, .lp__atc-form';

  function getDrawer() {
    var d = document.querySelector('cart-drawer-component');
    return (d && typeof d.open === 'function') ? d : null;
  }

  async function addToCart(form) {
    var drawer = getDrawer();
    if (!drawer) throw new Error('no-drawer');

    var cartItems = drawer.querySelector('cart-items-component');
    var sectionId = cartItems && cartItems.dataset ? cartItems.dataset.sectionId : null;

    var fd = new FormData(form);
    // Ask for the cart-drawer section so cart-items-component can morph it in
    // immediately (no empty flash, no stale drawer).
    if (sectionId) {
      fd.append('sections', sectionId);
      fd.append('sections_url', window.location.pathname);
    }

    var addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    });
    if (!addRes.ok) throw new Error('add-failed');
    var added = await addRes.json();

    var cart = await (await fetch('/cart.js')).json();

    // Native Horizon contract (events.js): cart-items-component morphs from
    // data.sections; cart-icon SETS the absolute count from data.itemCount when
    // source is not 'product-form-component'.
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'pf-cart',
        data: {
          source: 'pf-cart',
          itemCount: cart.item_count,
          sections: added.sections || undefined
        }
      }
    }));

    // PikeFit 2026-08-27: cart drawer restored (the line-item collapse that got
    // it retired is fixed by the CSS in cart-drawer.liquid + pf-freeship-bar).
    // Open the drawer in place — shopper sees items, free-shipping progress and
    // checkout instantly, can close it with the X and keep browsing. No more
    // full-page redirect to /cart.
    drawer.open();
    return true;
  }

  function onSubmit(e) {
    var form = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!form) return;
    if (!window.fetch || !window.FormData) return; // let native submit run
    if (!getDrawer()) return; // no drawer -> native return_to=/cart handles it

    e.preventDefault();
    // Capture phase: suppress any legacy inline submit handler (e.g. the old
    // best-sellers AJAX handler) so the item is never added twice.
    e.stopImmediatePropagation();

    var btn = form.querySelector('button[type="submit"]') || form.querySelector('button');
    var label = btn ? (btn.querySelector('span') || btn) : null;
    var original = label ? label.textContent : '';
    var addedText = btn ? btn.getAttribute('data-added-text') : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    addToCart(form).then(function () {
      if (!btn) return;
      if (addedText && label) { btn.classList.add('is-added'); label.textContent = addedText; }
      setTimeout(function () {
        btn.classList.remove('is-added');
        if (addedText && label) label.textContent = original;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }, 1800);
    }).catch(function () {
      // Never let add-to-cart silently fail: go to the standard cart page.
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      window.location.href = '/cart';
    });
  }

  // Capture phase so we intercept before any legacy inline handler.
  document.addEventListener('submit', onSubmit, true);
})();

/* PikeFit: mobile menu-drawer close safety net. The header drawer opens via the
   browser's native <details>/<summary> behavior, but on mobile the tap on the X /
   backdrop did not reliably trigger the theme's close. This guarantees that tapping
   the close button, the backdrop, or the summary (only while the drawer is open)
   closes it. It acts ONLY on an already-open drawer, so it can never block opening. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;
    var details = drawer.querySelector('details.menu-drawer-container');
    if (!details || !details.hasAttribute('open')) return; // only when the menu is open
    if (!t.closest('.menu-drawer__close-button, .menu-drawer__backdrop, summary.header__icon--menu')) return;
    // Force a clean close and stop the native toggle from re-opening it.
    e.preventDefault();
    e.stopImmediatePropagation();
    if (typeof drawer.close === 'function') { try { drawer.close(); } catch (err) {} }
    details.classList.remove('menu-open');
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }, true);
})();

/* PikeFit: Instagram feed tiles were a dead-click source (Clarity: ~5% of
   sessions had dead clicks). The .pf-ig__item photo/video tiles look like
   tappable Instagram posts (IG glyph overlay) but carried no link, so taps did
   nothing. Make each tile open the Instagram profile in a new tab, turning a
   frustrated dead click into an actual Instagram visit. Event-delegated so it
   survives the marquee's cloned tiles; adds cursor + keyboard + ARIA so it is
   an honest, accessible affordance. Skips any tile already inside a real link. */
(function () {
  var IG = 'https://www.instagram.com/pikefit_/';

  function decorate() {
    var tiles = document.querySelectorAll('.pf-ig__item');
    for (var i = 0; i < tiles.length; i++) {
      var t = tiles[i];
      if (t.getAttribute('data-pf-ig-linked') || t.closest('a')) continue;
      t.setAttribute('data-pf-ig-linked', '1');
      t.style.cursor = 'pointer';
      t.setAttribute('role', 'link');
      t.setAttribute('tabindex', '0');
      t.setAttribute('aria-label', 'View PikeFit on Instagram');
    }
  }

  function openIG() { window.open(IG, '_blank', 'noopener'); }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.pf-ig__item') : null;
    if (!t || t.closest('a[href]')) return;
    openIG();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target && e.target.closest ? e.target.closest('.pf-ig__item') : null;
    if (!t) return;
    e.preventDefault();
    openIG();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
  // Re-run once after the marquee clones its tiles / the section hydrates.
  setTimeout(decorate, 1200);
})();
